module.exports = __webpack_public_path__ + "img/lightning.49e7e323.svg";